import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-760ef20e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tamanho-completo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Característica"
}, "Característica", -1))
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ss-grade-personalizada-titulo ss-mover" }
const _hoisted_14 = { class: "ss-alinhar-centro" }
const _hoisted_15 = { class: "ss-titulo-destaque ss-texto-centralizado" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "ss-alinhar-centro" }
const _hoisted_18 = {
  key: 0,
  class: "ss-variacao-selecionar-caracteristicas"
}
const _hoisted_19 = {
  key: 1,
  class: "ss-variacao-selecionar-caracteristicas"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 3,
  class: "ss-margin-campos"
}
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = {
  key: 4,
  class: "ss-margin-campos"
}
const _hoisted_24 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_caracteristica = _resolveComponent("selecionar-caracteristica")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_card = _resolveComponent("card")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 1000,
      visible: _ctx.state.apresentarModalVariacao,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.apresentarModalVariacao) = $event)),
      title: "Novas variações do produto"
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.apresentarModalVariacao = false))
          }, _hoisted_3),
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.criaDefinicoesComVariacoes()))
          }, _hoisted_5)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                  label: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Defina uma ou mais características e selecione quais itens correspondem a variação de seu produto que vai ter informações específicas de estoque, preços, imagens e outros..."
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_icone, {
                          class: "ss-icone-informacao-campo",
                          nome: "informacao-campo"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_caracteristica, {
                      empresas: [_ctx.storeSistema.getters.codigoEmpresaOperacao()],
                      "codigo-selecionado": _ctx.state.codigoCaracteristicaSelecionada,
                      "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.codigoCaracteristicaSelecionada) = $event))
                    }, null, 8, ["empresas", "codigo-selecionado"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-primary ant-btn-block",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adicionarCaracteristica()))
                    }, _hoisted_11)
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.state.caracteristicasVariacao.length <= 0)
              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                  key: 0,
                  mensagem: "Nenhuma característica foi adicionada ainda"
                }))
              : (_ctx.state.caracteristicasVariacao.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.state.caracteristicasVariacao,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.caracteristicasVariacao) = $event)),
                      "item-key": "codigo",
                      handle: ".ss-mover",
                      class: "ant-row ss-variacao-caracteristicas"
                    }, {
                      item: _withCtx(({element,index}) => [
                        (_openBlock(), _createElementBlock("div", {
                          key: element.codigo,
                          class: "ant-col ant-col-xs-24 ant-col-xl-6"
                        }, [
                          _createVNode(_component_card, {
                            altura: 450,
                            titulo: (index + 1) + 'ª Característica',
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(element.descricao), 1),
                                  _createElementVNode("a", {
                                    class: "ss-alinhar-centro",
                                    title: "Remover característica",
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.removerCaracteristica(index))
                                  }, [
                                    _createVNode(_component_icone, {
                                      class: "ss-icone-informacao-campo",
                                      nome: "excluir"
                                    })
                                  ], 8, _hoisted_16)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_a_checkbox, {
                                    checked: element.imprimirVendaNfe,
                                    "onUpdate:checked": ($event: any) => ((element.imprimirVendaNfe) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Imprimir na Venda/NF-e ")
                                    ]),
                                    _: 2
                                  }, 1032, ["checked", "onUpdate:checked"])
                                ])
                              ]),
                              (element.tipo === _ctx.ETipoCaracteristica.ListaSimples)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.itens, (itemCaracteristica) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "ss-margin-campos",
                                        key: itemCaracteristica.codigoItem
                                      }, [
                                        _createVNode(_component_a_checkbox, {
                                          checked: itemCaracteristica.selecionado,
                                          "onUpdate:checked": ($event: any) => ((itemCaracteristica.selecionado) = $event)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(itemCaracteristica.valor), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["checked", "onUpdate:checked"])
                                      ]))
                                    }), 128))
                                  ]))
                                : (element.tipo === _ctx.ETipoCaracteristica.Cor)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.itens, (itemCaracteristica) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "ss-margin-campos",
                                          style: {"display":"flex","align-items":"center"},
                                          key: itemCaracteristica.codigoItem
                                        }, [
                                          _createElementVNode("span", {
                                            style: _normalizeStyle('width: 16px;height: 16px;border-radius: 3px;margin-right: 6px;background-color:' + itemCaracteristica.valorVisual)
                                          }, null, 4),
                                          _createVNode(_component_a_checkbox, {
                                            checked: itemCaracteristica.selecionado,
                                            "onUpdate:checked": ($event: any) => ((itemCaracteristica.selecionado) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(itemCaracteristica.valor), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["checked", "onUpdate:checked"])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (element.tipo === _ctx.ETipoCaracteristica.ListaSubItens)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.itens, (itemCaracteristica) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "ss-variacao-selecionar-caracteristicas ss-margin-campos",
                                            key: itemCaracteristica.codigoItem
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(itemCaracteristica.valor), 1),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemCaracteristica.subItens, (subItemCaracteristica) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: subItemCaracteristica.codigoSubItem
                                              }, [
                                                _createVNode(_component_a_checkbox, {
                                                  checked: subItemCaracteristica.selecionado,
                                                  "onUpdate:checked": ($event: any) => ((subItemCaracteristica.selecionado) = $event)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(subItemCaracteristica.valor), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["checked", "onUpdate:checked"])
                                              ]))
                                            }), 128))
                                          ]))
                                        }), 128))
                                      ]))
                                    : (element.tipo === _ctx.ETipoCaracteristica.TextoLivre)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            maxlength: "250",
                                            "onUpdate:modelValue": ($event: any) => ((element.valorPersonalizado) = $event)
                                          }, null, 8, _hoisted_22), [
                                            [_vModelText, element.valorPersonalizado]
                                          ])
                                        ]))
                                      : (element.tipo === _ctx.ETipoCaracteristica.Numero || element.tipo === _ctx.ETipoCaracteristica.Decimal)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              class: "ant-input",
                                              "onUpdate:modelValue": ($event: any) => ((element.valorPersonalizado) = $event)
                                            }, null, 8, _hoisted_24), [
                                              [_vModelText, element.valorPersonalizado]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["titulo"])
                        ]))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}